import React from "react";
import { userAuthAPI } from "../../api/userAuthAPI";
import useUserStore from "../../zustand/UseUserStore";

/**
 * ContestSwitcher - Contest navigation carousel component
 * Allows users to switch between contests with arrow buttons
 */
const ContestSwitcher = ({
	contests,
	currentContestId,
	onContestChange,
	getContestIndexFromIDLocal,
	getContestIDFromIndexLocal,
	userStore,
}) => {
	if (!contests || contests.length === 0) {
		return null;
	}

	const handlePrevious = async () => {
		const currentIndex = getContestIndexFromIDLocal(currentContestId);
		const newIndex =
			currentIndex === 0 ? contests.length - 1 : currentIndex - 1;
		const contestID = getContestIDFromIndexLocal(newIndex);

		onContestChange(contestID);

		// Update PrevContest if not "Glow Game"
		if (contestID !== 0) {
			try {
				await userAuthAPI.updateMember({
					MemberID: userStore.user?.MemberID,
					PrevContest: contestID,
				});
				console.log("✅ Updated PrevContest in database:", contestID);

				const currentUser = useUserStore.getState().user;
				useUserStore.setState({
					user: {
						...currentUser,
						PrevContest: contestID,
					},
				});
			} catch (error) {
				console.error("❌ Failed to update PrevContest:", error);
			}
		}
	};

	const handleNext = async () => {
		const currentIndex = getContestIndexFromIDLocal(currentContestId);
		const newIndex = (currentIndex + 1) % contests.length;
		const contestID = getContestIDFromIndexLocal(newIndex);

		onContestChange(contestID);

		// Update PrevContest if not "Glow Game"
		if (contestID !== 0) {
			try {
				await userAuthAPI.updateMember({
					MemberID: userStore.user?.MemberID,
					PrevContest: contestID,
				});
				console.log("✅ Updated PrevContest in database:", contestID);

				const currentUser = useUserStore.getState().user;
				useUserStore.setState({
					user: {
						...currentUser,
						PrevContest: contestID,
					},
				});
			} catch (error) {
				console.error("❌ Failed to update PrevContest:", error);
			}
		}
	};

	const currentIndex = getContestIndexFromIDLocal(currentContestId);
	const currentContestName = contests[currentIndex];
	const isGlowGame = currentContestName?.toLowerCase() === "glow game";

	return (
		<div className="rounded-lg border-2 border-purple-300 bg-white px-4 py-3 shadow-lg dark:border-purple-700 dark:bg-gray-800">
			<div className="flex w-full min-w-0 items-center justify-between gap-2 sm:gap-4">
				{contests.length > 1 && (
					<button
						onClick={handlePrevious}
						className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full border-2 border-purple-300 bg-white font-bold text-purple-600 shadow-sm transition-colors hover:bg-purple-100 dark:border-purple-600 dark:bg-gray-700 dark:text-purple-400 dark:hover:bg-purple-800"
					>
						‹
					</button>
				)}
				<div className="min-w-0 flex-1 text-center">
					<div className="mb-1 text-xs font-semibold uppercase tracking-wider text-gray-600 dark:text-gray-300 sm:text-sm">
						Viewing
					</div>
					<div
						className={`truncate text-xl font-black tracking-tight sm:text-2xl ${
							isGlowGame
								? "text-orange-400 drop-shadow-[0_2px_8px_rgba(251,146,60,0.6)] dark:text-orange-200"
								: "bg-gradient-to-r from-purple-600 via-pink-600 to-purple-600 bg-clip-text text-transparent drop-shadow-[0_2px_8px_rgba(168,85,247,0.4)]"
						}`}
					>
						{currentContestName}
					</div>
				</div>
				{contests.length > 1 && (
					<button
						onClick={handleNext}
						className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full border-2 border-purple-300 bg-white font-bold text-purple-600 shadow-sm transition-colors hover:bg-purple-100 dark:border-purple-600 dark:bg-gray-700 dark:text-purple-400 dark:hover:bg-purple-800"
					>
						›
					</button>
				)}
			</div>
		</div>
	);
};

export default ContestSwitcher;
